module.exports = __webpack_public_path__ + "img/noOrder.4105a9a2.png";